import { Box, Grid, Menu } from '@mui/material';
import dayjs from 'dayjs';
import React, { useState, MouseEvent } from 'react';
import {
  formattedDateISO,
  WsDateTimePicker,
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  WsButton,
} from 'wisestep-base';

interface DueDateTimeFilterProps {
  onChange: (value: string) => void;
}

const DueDateTimeFilter: React.FC<DueDateTimeFilterProps> = ({ onChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [selectedOption, setSelectedOption] = useState<string>('All');
  const [selectedCustomDate, setSelectedCustomDate] = useState<Date | null>(null);
  const [showCustom, setShowCustom] = useState(false);
  const timeArr = ['15m', '30m', '1h', '2h', '1d', '3d', '5d'];
  const addingTime: Record<string, () => dayjs.Dayjs> = {
    '15m': () => dayjs().add(15, 'minute'),
    '30m': () => dayjs().add(30, 'minute'),
    '1h': () => dayjs().add(1, 'hour'),
    '2h': () => dayjs().add(2, 'hour'),
    '1d': () => dayjs().add(1, 'day'),
    '3d': () => dayjs().add(3, 'day'),
    '5d': () => dayjs().add(5, 'day'),
  };

  const handleClick = (event: MouseEvent<HTMLDivElement>) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleSelectOption = (option: string) => {
    if (option === 'custom') {
      setShowCustom(true);
      setSelectedOption('custom');
    } else {
      setShowCustom(false);
      setSelectedOption(option);
      setSelectedCustomDate(null);
    }
  };

  const handleApply = () => {
    let timePeriod = '';
    if (selectedOption !== 'All' && selectedOption !== 'custom') {
      const dateTime = addingTime[selectedOption]();
      timePeriod = formattedDateISO(dateTime.toDate());
    } else if (selectedOption === 'custom' && selectedCustomDate) {
      timePeriod = formattedDateISO(selectedCustomDate);
    }
    onChange(timePeriod);
    handleClose();
  };

  return (
    <>
      <Grid container gap={1} alignItems="center" onClick={handleClick}>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
          Due Date/Time:
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.PRIMARY}>
          {selectedOption === 'custom' && selectedCustomDate
            ? dayjs(selectedCustomDate).format('DD/MM/YYYY hh:mm A')
            : selectedOption}
        </WsTypography>
      </Grid>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        keepMounted
        PaperProps={{ sx: { p: 2 } }}
      >
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
          {timeArr.map((time) => (
            <WsButton
              key={time}
              variant="outlined"
              onClick={() => handleSelectOption(time)}
              size="medium"
            >
              {time}
            </WsButton>
          ))}
          <WsButton variant="outlined" onClick={() => handleSelectOption('custom')} size="medium">
            Custom
          </WsButton>
          <WsButton variant="contained" onClick={handleApply} size="medium">
            Apply
          </WsButton>
        </Box>
        {showCustom && (
          <Box sx={{ mt: 2 }}>
            <WsDateTimePicker name="customTime" label="Custom Date" disablePast />
          </Box>
        )}
      </Menu>
    </>
  );
};

export default DueDateTimeFilter;
